import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { } from '@fortawesome/free-brands-svg-icons';
import {
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faEllipsisH,
	faCheckCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faTrashCanUndo,
	faPrint,
	faFileInvoice,
	faAlarmClock,
	faGripDotsVertical,
	faCirclePause,
	faCirclePlay,
	faCircleCheck,
	faCircleXmark,
	faReceipt,
	faFileInvoiceDollar,
	faArrowRightFromLine,
	faArrowLeftFromLine,
	faEnvelope,
	faSlidersH,
	faClipboardList,
	faPenToSquare,
	faChevronDown,
	faChevronRight,
	faChevronLeft,
	faTimes as faTimesRegular,
	faLink,
	faUnlink,
	faRedo,
	faExternalLink,
	faFilePdf
} from '@fortawesome/pro-regular-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

library.add(
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faTimes,
	faTimesRegular,
	faEllipsisH,
	faCheckCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAlarmClock,
	faGripDotsVertical,
	faCirclePause,
	faCirclePlay,
	faReceipt,
	faFileInvoiceDollar,
	faCircleCheck,
	faCircleXmark,
	faArrowRightFromLine,
	faArrowLeftFromLine,
	faEnvelope,
	faTrashCanUndo,
	faSlidersH,
	faClipboardList,
	faPenToSquare,
	faChevronDown,
	faChevronRight,
	faChevronLeft,
	faLink,
	faUnlink,
	faRedo,
	faExternalLink,
	faFilePdf
);

dom.watch();
